import Alert from '@anm/components/notification/Alert';
import ShareVideoPage from '@anm/components/share/ShareVideoPage';
import useSwitchState from '@anm/hooks/useSwitchState';
import { media } from '@anm/styles/helpers';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import vtConfig from '../../../../../../config';
import { projectSelectors } from '../../../../../../store/modules/project';
import { useNoDataHandlers } from '../hooks';
import { AnalyticsTabProps } from '../types';

const { urls } = vtConfig();

const wrapperOnMobile = media.phone`
  padding: 0;
`;

const Wrapper = styled.div`
  margin-top: 24px;
  margin-bottom: 6px;
  padding-right: 50px;
  p {
    margin: 0;
    color: #292a2b;
    a,
    span {
      color: inherit;
      cursor: pointer;
      text-decoration: underline;
    }
  }
  ${wrapperOnMobile};
`;

const NotHostedVideoWarning: FC<AnalyticsTabProps> = props => {
  const [
    videoId,
    shareLink,
    landingTabUrl,
    navigateToEmbedTab
  ] = useNoDataHandlers(props);
  const [isModalOpen, openModal, closeModal] = useSwitchState();

  const isProjectEverRender = useSelector(
    projectSelectors.selectCurrentProjectEverRendered
  );

  if (isProjectEverRender) return null;

  return (
    <>
      {isModalOpen && (
        <ShareVideoPage
          {...{ shareLink, landingTabUrl }}
          onClose={closeModal}
        />
      )}
      <Wrapper>
        <Alert variant="warning" position="center">
          <p>
            This video has never been published.&nbsp;
            <a href={`${urls.editor}/#p=${videoId}&target=publish`}>
              Open in the editor
            </a>
            &nbsp;to publish it and then&nbsp;
            <span onClick={openModal}>share</span> or&nbsp;
            <a
              onClick={navigateToEmbedTab}
              href={`${urls.wave}video/${videoId}/embed`}
            >
              embed the video
            </a>
            &nbsp;to see the results here.
          </p>
        </Alert>
      </Wrapper>
    </>
  );
};

export default NotHostedVideoWarning;
